<template>
  <apexchart v-if="score !== undefined" :width="width" :height="height" :options="chartOptions" :series="chartSeries"></apexchart>
</template>
<script>

export default {
  name: 'TitleScore',
  components: { },
  props: ['score', 'height', 'width', 'label', 'color'],

  computed: {
    chartSeries() {
      return [this.score]
    },
    chartColor() {
      return this.color || this.score >= process.env.VUE_APP_SCORE_HIGH ? 'success' : this.score >= process.env.VUE_APP_SCORE_MEDIUM ? 'warning' : 'danger'
    },
    chartOptions() {
      return {
        chart: {
          type: 'radialBar',
          sparkline: {
            enabled: true
          },
          animations: {
            easing: 'easeout',
            speed: 1000,
            dynamicAnimation: {
              speed: 1000
            }
          }
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: '70%'
            },
            track: {
              margin: 0
            },
            dataLabels: {
              show: this.width > 50,
              name: {
                offsetY: 5,
              },
              value: {
                show: false
              },
            },
          }
        },
        tooltip: {
          enabled: false,
          fillSeriesColor: false,
        },
        labels: [this.label || this.score],
        colors: [`var(--${this.chartColor})`],
      }
    },
  },
}
</script>
